
define( 'FORCES_AND_MOTION_BASICS/../nls/ca/forces-and-motion-basics-strings',{
          "none": "Res",
          "force": "Força",
          "values": "Valors",
          "frictionTitle": "Fricció",
          "redWins": "Guanya l'equip vermell!",
          "frictionForce": "Força de fricció",
          "pause": "Pausa",
          "friction": "Fricció",
          "forces-and-motion-basics.name": "Les forces i el moviment. Nivell bàsic",
          "appliedForce": "Força Aplicada",
          "leftForce": "Força esquerra",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Força dreta",
          "sound": "So",
          "lots": "Molts",
          "forces": "Forces",
          "motion": "Moviment",
          "tugOfWar": "Estira la corda",
          "go": "Prova!",
          "newtons.n": "Newtons (N)",
          "sumOfForcesEqualsZero": "Suma de forces = 0",
          "blueWins": "Guanya l'equip blau!",
          "speed": "Velocitat",
          "sumOfForces": "Suma de forces",
          "return": "Torna-hi",
          "translation.credits": "Valentí Ferrer",
          "newtons": "Newtons",
          "masses": "Massa",
          "forceReadout.pattern": "{0}N"
        } );